const state = () => ({
   stages: [
      {
         id: 'dashboard',
         name: 'Dashboard',
         icon: 'icon-dashboard',
         active: false,
         route: 'Home',
         requirements: {
            appState: ['isAppConfigured'],
            customer: [],
            sme: [],
         },
      },
      {
         id: 'get-started',
         name: 'What Qualifies?',
         icon: 'icon-qualify',
         active: false,
         route: 'get-started-stage',
         requirements: {
            appState: [],
            customer: [],
            sme: [],
         },
      },
      {
         id: 'time',
         name: 'Employee Time',
         icon: 'icon-chronometer',
         active: false,
         route: 'employees-table',
         requirements: {
            appState: ['isAppConfigured'],
            customer: [],
            sme: ['employees/hasSectionAssignment'],
         },
      },
      {
         id: 'contractors',
         name: 'Contract Research',
         icon: 'icon-contractor',
         active: false,
         route: 'contractors-table',
         requirements: {
            appState: ['isAppConfigured'],
            customer: [],
            sme: [],
         },
      },
      {
         id: 'supplies',
         name: 'Supplies',
         icon: 'icon-supplies',
         active: false,
         route: 'supplies-table',
         requirements: {
            appState: ['isAppConfigured'],
            customer: [],
            sme: [],
         },
      },
      {
         id: 'cloud',
         name: 'Cloud Computing',
         icon: 'icon-cloud-computing',
         active: false,
         route: 'cloud-table',
         requirements: {
            appState: ['isAppConfigured'],
            customer: [],
            sme: [],
         },
      },
      {
         id: 'questionnaire',
         name: 'Questionnaires',
         icon: 'icon-questions',
         active: false,
         route: 'questionnaires',
         requirements: {
            appState: ['isAppConfigured', 'progress/hasQuestionnaireAssignment'],
            customer: [],
            sme: [],
         },
      },
      {
         id: 'study-setup',
         name: 'Study Setup',
         icon: 'icon-study-setup',
         active: false,
         route: 'study-setup',
         requirements: {
            appState: [],
            customer: [],
            sme: [],
         },
      },
      {
         id: 'flags',
         name: 'Flags',
         icon: 'icon-flags',
         active: false,
         route: 'flags-and-issues',
         requirements: {
            appState: ['isAppConfigured'],
            customer: [],
            sme: [],
         },
      },
   ],
});

const getters = {
   /** Stages currently accessible to the current user */
   stages: (state, getters, rootState, rootGetters) => {
      return state.stages.filter((stage) => {
         let include = true;

         const requirements = [
            ...stage.requirements.appState,
            ...(getters.isCustomer ? stage.requirements.customer : []),
            ...(getters.isSME ? stage.requirements.sme : []),
         ];

         requirements.forEach((item) => {
            include = include && rootGetters[item];
         });

         if (include && getters.isSME && stage.requirements.smeAnyOf?.length) {
            include = stage.requirements.smeAnyOf.some((item) => rootGetters[item]);
         }

         return include;
      });
   },

   /** The currently active stage */
   activeStage: (state, getters) => {
      const active = getters.stages.find((stage) => stage.active);
      return active ? active : null;
   },

   /** The stage immediately after the current active stage */
   nextStage: (state, getters) => {
      if (getters.activeStage === null || getters.activeStage.id === 'dashboard') {
         return null;
      }

      const idx = getters.stages.indexOf(getters.activeStage);
      if (idx < getters.stages.length - 1) {
         return getters.stages[idx + 1];
      }
      return null;
   },

   /** The stage immediately preceding the current active stage */
   previousStage: (state, getters) => {
      if (getters.activeStage === null || getters.activeStage.id === 'dashboard') {
         return null;
      }

      const idx = getters.stages.indexOf(getters.activeStage);
      if (idx > 1) {
         // The first stage (dashboard) has no previous, and is itself
         // not considered previous to the second stage. Start considering
         // stages as a sequence from getters.stages[1]
         return getters.stages[idx - 1];
      }
      return null;
   },
};

const mutations = {
   setActiveStage(state, id) {
      state.stages.forEach((stage) => {
         stage.active = stage.id === id;
      });
   },
};

export default {
   state,
   getters,
   mutations,
};
